/* Mampacha Klar, Theme JS (vanilla, keine Abhängigkeiten) */
(function () {
  'use strict';
  var MP = window.MP || {};
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) {
    try { return new Intl.NumberFormat(MP.locale || 'de-DE', { style: 'currency', currency: MP.currency || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  };
  var toast = function (msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('show'); }, 2600);
  };

  /* ---------- Dialoge (Warenkorb, Suche, Filter) ---------- */
  var openStack = [];
  function Dialog(el, opts) {
    opts = opts || {};
    var last = null;
    var api = {
      el: el,
      isOpen: function () { return el.classList.contains('open'); },
      open: function (focusSel) {
        last = document.activeElement;
        el.classList.add('open'); el.removeAttribute('aria-hidden');
        document.body.style.overflow = 'hidden';
        openStack.push(api);
        setTimeout(function () {
          var t = (focusSel && $(focusSel, el)) || focusables()[0];
          if (t) t.focus();
        }, 40);
        if (opts.onOpen) opts.onOpen();
      },
      close: function () {
        if (!api.isOpen()) return;
        el.classList.remove('open'); el.setAttribute('aria-hidden', 'true');
        openStack = openStack.filter(function (d) { return d !== api; });
        if (!openStack.length) document.body.style.overflow = '';
        if (last && last.focus) last.focus();
        if (opts.onClose) opts.onClose();
      }
    };
    function focusables() {
      return $$('button,a[href],input,select,textarea', el).filter(function (x) { return !x.disabled && x.offsetParent !== null; });
    }
    api.focusables = focusables;
    return api;
  }
  document.addEventListener('keydown', function (e) {
    var top = openStack[openStack.length - 1];
    if (e.key === 'Escape') {
      if (top) { top.close(); return; }
      var nv = $('#nv'), bg = $('#bg');
      if (nv && nv.classList.contains('open')) { nv.classList.remove('open'); bg.setAttribute('aria-expanded', 'false'); $('#hd').classList.remove('menu-open'); }
    }
    if (e.key === 'Tab' && top) {
      var f = top.focusables(); if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    }
  });

  /* ---------- Header ---------- */
  var hd = $('#hd');
  if (hd) {
    if (hd.getAttribute('data-transparent') === 'true') {
      var upd = function () {
        var p = Math.min(Math.max(window.scrollY / 140, 0), 1);
        hd.style.setProperty('--p', p.toFixed(3)); hd.style.setProperty('--ps', p.toFixed(3));
        hd.classList.toggle('scrolled', p > 0.5);
      };
      upd(); window.addEventListener('scroll', upd, { passive: true });
    }
    var bg = $('#bg'), nv = $('#nv');
    if (bg && nv) {
      bg.addEventListener('click', function () {
        var o = nv.classList.toggle('open');
        bg.setAttribute('aria-expanded', o); hd.classList.toggle('menu-open', o);
      });
      nv.addEventListener('click', function (e) {
        if (!e.target.closest('a')) return;
        nv.classList.remove('open'); bg.setAttribute('aria-expanded', 'false'); hd.classList.remove('menu-open');
      });
    }
    $$('[data-mega]').forEach(function (mi) {
      var btn = $('.chev', mi), t;
      var open = function () { clearTimeout(t); mi.classList.add('open'); hd.classList.add('mega-open'); btn.setAttribute('aria-expanded', 'true'); };
      var close = function () { mi.classList.remove('open'); hd.classList.remove('mega-open'); btn.setAttribute('aria-expanded', 'false'); };
      var hov = window.matchMedia('(hover:hover) and (min-width:1001px)');
      mi.addEventListener('mouseenter', function () { if (hov.matches) open(); });
      mi.addEventListener('mouseleave', function () { if (hov.matches) t = setTimeout(close, 200); });
      btn.addEventListener('click', function () { mi.classList.contains('open') ? close() : open(); });
      mi.addEventListener('focusout', function (e) { if (!mi.contains(e.relatedTarget) && hov.matches) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mi.classList.contains('open')) { close(); btn.focus(); } });
      document.addEventListener('click', function (e) { if (!mi.contains(e.target) && mi.classList.contains('open')) close(); });
    });
  }

  /* ---------- Reveal, Zähler, Parallax ---------- */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12 });
  function initReveal(root) {
    $$('.rv', root).forEach(function (el) { if (RM) el.classList.add('in'); io.observe(el); });
  }
  initReveal();
  var co = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target, n = +el.dataset.n, s = performance.now();
      if (RM) { el.textContent = n; return; }
      (function f(t) { var p = Math.min((t - s) / 1600, 1); el.textContent = Math.round(n * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(f); })(s);
      co.unobserve(el);
    });
  }, { threshold: 0.6 });
  $$('[data-n]').forEach(function (el) { co.observe(el); });
  var par = $$('[data-speed]');
  if (par.length && !RM) window.addEventListener('scroll', function () {
    par.forEach(function (el) { var r = el.parentElement.getBoundingClientRect(); el.style.transform = 'translateY(' + ((r.top - innerHeight / 2) * el.dataset.speed) + 'px)'; });
  }, { passive: true });

  /* ---------- Slider (Hero, Kundenstimmen) ---------- */
  function Slider(items, dots, ms, autoplay) {
    var i = 0, t, api = {};
    function restartDot() { var d = dots[i]; if (!d) return; d.classList.remove('on'); void d.offsetWidth; d.classList.add('on'); }
    function reset() { clearInterval(t); restartDot(); if (autoplay && !RM && items.length > 1) t = setInterval(function () { api.go(i + 1); }, ms); }
    api.go = function (n) {
      items[i].classList.remove('on'); if (dots[i]) { dots[i].classList.remove('on'); dots[i].removeAttribute('aria-current'); }
      items[i].setAttribute('aria-hidden', 'true');
      i = (n + items.length) % items.length;
      items[i].classList.add('on'); items[i].removeAttribute('aria-hidden');
      if (dots[i]) dots[i].setAttribute('aria-current', 'true');
      reset();
    };
    api.cur = function () { return i; };
    items.forEach(function (el, n) { if (n) el.setAttribute('aria-hidden', 'true'); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { api.go(n); }); });
    var box = items[0].parentElement;
    box.addEventListener('mouseenter', function () { clearInterval(t); });
    box.addEventListener('mouseleave', reset);
    box.addEventListener('focusin', function () { clearInterval(t); });
    box.addEventListener('focusout', reset);
    var sx = null;
    box.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (sx === null) return; var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 50) api.go(i + (dx < 0 ? 1 : -1)); sx = null;
    });
    reset();
    return api;
  }
  $$('[data-hero]').forEach(function (hero) {
    var slides = $$('.slide', hero), dots = $$('[data-hero-dots] .dot', hero);
    if (slides.length > 1) {
      var s = Slider(slides, dots, +hero.dataset.interval || 6000, hero.dataset.autoplay === 'true');
      var nx = $('[data-hero-next]', hero), pv = $('[data-hero-prev]', hero);
      if (nx) nx.addEventListener('click', function () { s.go(s.cur() + 1); });
      if (pv) pv.addEventListener('click', function () { s.go(s.cur() - 1); });
    }
    var sc = $('[data-scroll-next]', hero);
    if (sc) sc.addEventListener('click', function (e) {
      e.preventDefault();
      var wrap = hero.closest('.shopify-section') || hero;
      var nxt = wrap.nextElementSibling;
      if (nxt) nxt.scrollIntoView({ behavior: RM ? 'auto' : 'smooth' });
    });
  });
  $$('[data-quotes]').forEach(function (sec) {
    var items = $$('.q', sec), dots = $$('[data-quote-dots] .dot', sec);
    if (items.length > 1) Slider(items, dots, 6000, true);
  });

  /* ---------- Rail ---------- */
  $$('[data-rail]').forEach(function (rail) {
    rail.setAttribute('data-rail-keys', '');
    var down = false, sx, sl;
    rail.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') rail.scrollBy({ left: 340, behavior: 'smooth' });
      if (e.key === 'ArrowLeft') rail.scrollBy({ left: -340, behavior: 'smooth' });
    });
    rail.addEventListener('mousedown', function (e) { down = true; sx = e.pageX; sl = rail.scrollLeft; rail.style.scrollSnapType = 'none'; });
    window.addEventListener('mouseup', function () { down = false; rail.style.scrollSnapType = ''; });
    rail.addEventListener('mousemove', function (e) { if (down) rail.scrollLeft = sl - (e.pageX - sx); });
  });

  /* ---------- Warenkorb ---------- */
  var cartEl = $('#mc');
  var cartDlg = cartEl ? Dialog(cartEl) : null;
  function setCounts(n) {
    $$('[data-cart-count]').forEach(function (c) { c.textContent = n; });
    $$('.cnt[data-cart-count]').forEach(function (c) { c.hidden = !(parseInt(n, 10) > 0); });
    $$('[data-cart-open]').forEach(function (a) { a.setAttribute('aria-label', 'Warenkorb, ' + n + ' Artikel'); });
  }
  function refreshCart() {
    return fetch(MP.routes.cart + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (data) {
      var html = data['cart-drawer']; if (!html || !cartEl) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var np = $('.mc-p', doc), op = $('.mc-p', cartEl);
      if (np && op) op.innerHTML = np.innerHTML;
      var n = $('[data-cart-count]', doc); if (n) setCounts(n.textContent);
    });
  }
  function refreshCartPage() {
    if (!$('.cart, .emptyc')) return Promise.resolve();
    return fetch(location.href).then(function (r) { return r.text(); }).then(function (t) {
      var doc = new DOMParser().parseFromString(t, 'text/html');
      var nm = $('#main', doc), om = $('#main');
      if (nm && om) { om.innerHTML = nm.innerHTML; initReveal(om); }
    });
  }
  function cartAdd(body, quiet) {
    return fetch(MP.routes.cartAdd, { method: 'POST', headers: { 'Accept': 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || MP.strings.error); return j; }); })
      .then(function () { return refreshCart(); })
      .then(function () { if (cartDlg && !quiet && !cartDlg.isOpen()) cartDlg.open('.mc-x'); });
  }
  /* Geschenkverpackung: Schmuckkaestchen per Haekchen dazulegen oder entfernen */
  document.addEventListener('change', function (e) {
    var t = e.target.closest ? e.target.closest('[data-gift-toggle]') : null; if (!t) return;
    t.disabled = true;
    var p;
    if (t.checked) { var fd = new FormData(); fd.append('id', t.dataset.variant); fd.append('quantity', 1); p = cartAdd(fd, true).then(refreshCartPage); }
    else { p = cartChange(t.dataset.line, 0); }
    p.catch(function (err) { toast(err.message || MP.strings.error); t.checked = !t.checked; t.disabled = false; });
  });
  function cartChange(line, qty) {
    return fetch(MP.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { if (!r.ok) throw new Error(MP.strings.error); return r.json(); })
      .then(function (cart) { setCounts(cart.item_count); return Promise.all([refreshCart(), refreshCartPage()]); });
  }
  if (cartDlg) {
    $$('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); cartDlg.open('.mc-x'); });
    });
    cartEl.addEventListener('click', function (e) { if (e.target.closest('[data-cart-close]')) cartDlg.close(); });
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-line-qty]');
    if (q) {
      var line = q.dataset.lineQty, qty = +q.dataset.qty, key = q.className;
      cartChange(line, qty).then(function () {
        if (qty === 0) toast(MP.strings.removed);
        var again = document.querySelector('[data-line-qty="' + line + '"][data-qty]'); if (again && qty > 0) again.focus();
      }).catch(function () { toast(MP.strings.error); });
      return;
    }
    var a = e.target.closest('[data-add-variant]');
    if (a && !a.disabled) {
      var fd = new FormData(); fd.append('id', a.dataset.addVariant); fd.append('quantity', 1);
      a.disabled = true;
      cartAdd(fd).catch(function (err) { toast(err.message); }).then(function () { a.disabled = false; });
    }
  });

  /* ---------- Suche Overlay ---------- */
  var so = $('#so');
  if (so) {
    var sDlg = Dialog(so, { onOpen: function () { var i = $('#sq'); if (i) i.focus(); } });
    var inp = $('#sq'), res = $('#sres'), hdr = $('#sh'), pop = $('#spop'), timer, defaultRes = res.innerHTML, defaultHdr = hdr.textContent;
    $$('[data-search-open]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); sDlg.open('#sq'); }); });
    $('#sclose').addEventListener('click', function () { sDlg.close(); });
    inp.addEventListener('input', function () {
      clearTimeout(timer);
      var q = inp.value.trim();
      if (!q) { res.innerHTML = defaultRes; hdr.textContent = defaultHdr; if (pop) pop.hidden = false; return; }
      timer = setTimeout(function () {
        var url = MP.routes.predictive + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product,page,collection&resources[limit]=4';
        fetch(url).then(function (r) { return r.text(); }).then(function (t) {
          var doc = new DOMParser().parseFromString(t, 'text/html');
          var box = $('[data-predictive-count]', doc);
          if (box && box.children.length) { res.innerHTML = box.innerHTML; hdr.textContent = box.children.length + ' Treffer'; }
          else { res.innerHTML = ''; hdr.textContent = 'Keine Treffer'; }
          if (pop) pop.hidden = true;
        }).catch(function () {});
      }, 220);
    });
  }

  /* ---------- Produktseite ---------- */
  $$('[data-product-section]').forEach(function (sec) {
    var jsonEl = $('[data-product-json]', sec.parentElement) || $('[data-product-json]');
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var form = $('[data-product-form]', sec);
    var track = $('[data-gtrack]', sec), thumbs = $$('[data-thumb]', sec), dots = $$('[data-gdots] i', sec), cnt = $('[data-gcount]', sec);
    var slides = track ? $$('.gs', track) : [];
    var gi = 0, N = slides.length;
    function show(i) {
      gi = i;
      thumbs.forEach(function (b, n) { b.setAttribute('aria-current', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('on', n === i); });
      if (cnt) cnt.textContent = (i + 1) + ' / ' + N;
    }
    function goTo(i) { i = (i + N) % N; track.scrollTo({ left: i * track.clientWidth, behavior: RM ? 'auto' : 'smooth' }); }
    if (track && N > 1) {
      track.addEventListener('scroll', function () { var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== gi) show(i); }, { passive: true });
      thumbs.forEach(function (b, n) { b.addEventListener('click', function () { goTo(n); }); });
      var gp = $('[data-gprev]', sec), gn = $('[data-gnext]', sec);
      if (gp) gp.addEventListener('click', function () { goTo(gi - 1); });
      if (gn) gn.addEventListener('click', function () { goTo(gi + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(gi + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(gi - 1); }
      });
    }
    if (!form || !product) return;
    var idInput = $('[data-variant-id]', form), addBtn = $('[data-add-to-cart]', form), stock = $('[data-stock]', sec);
    var priceEl = $('[data-price]', sec), cmpEl = $('[data-compare]', sec), sbar = $('[data-sbar]'), sbPrice = $('[data-sbar-price]'), sbAdd = $('[data-sbar-add]');
    var fieldsets = $$('fieldset[data-option-index]', form);
    var colorIdx = fieldsets.findIndex(function (fs) { return !!$('.sw', fs); });
    var delivery = stock ? stock.dataset.delivery : '';
    function selected() { return fieldsets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function findVariant(sel) { return product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0]; }
    function update() {
      var sel = selected(), v = product.variants.length === 1 ? product.variants[0] : findVariant(sel);
      fieldsets.forEach(function (fs, i) {
        var lab = $('[data-option-label]', fs); if (lab) lab.textContent = sel[i];
        $$('input', fs).forEach(function (r) {
          var test = sel.slice(); test[i] = r.value;
          var m = findVariant(test);
          r.disabled = !m; var sp = r.nextElementSibling; if (sp) sp.style.opacity = (m && !m.available) ? '.45' : '';
        });
      });
      if (!v) { addBtn.disabled = true; addBtn.textContent = MP.strings.soldOut; return; }
      idInput.value = v.id;
      if (priceEl) { priceEl.textContent = money(v.price); priceEl.classList.toggle('sale-price', v.compare_at_price > v.price); }
      if (cmpEl) { if (v.compare_at_price > v.price) { cmpEl.textContent = money(v.compare_at_price); cmpEl.hidden = false; } else cmpEl.hidden = true; }
      if (sbPrice) sbPrice.textContent = money(v.price);
      addBtn.disabled = !v.available; addBtn.textContent = v.available ? MP.strings.addToCart : MP.strings.soldOut;
      if (sbAdd) sbAdd.disabled = !v.available;
      if (stock) stock.textContent = v.available ? (stock.dataset.instock || 'Auf Lager') : 'Derzeit ausverkauft';
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
      if (track) {
        var idx = -1;
        if (v.featured_media) idx = slides.findIndex(function (s) { return String(s.dataset.mediaId) === String(v.featured_media.id); });
        /* Kein Variantenbild: erstes Foto, dessen Alt-Text den gewählten Farbnamen als Wort enthält */
        if (idx < 0 && colorIdx > -1 && sel[colorIdx]) {
          var key = ' ' + sel[colorIdx].toLowerCase() + ' ';
          idx = slides.findIndex(function (s) { var im = s.querySelector('img'); return !!im && (' ' + (im.getAttribute('alt') || '').toLowerCase().replace(/[,.\-]/g, ' ') + ' ').indexOf(key) > -1; });
        }
        if (idx > -1 && idx !== gi) goTo(idx);
      }
    }
    form.addEventListener('change', function (e) { if (e.target.matches('[data-option-value]')) update(); });
    update();
    var qty = $('[data-qty-input]', form);
    var minus = $('[data-qty-minus]', form), plus = $('[data-qty-plus]', form);
    if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (+qty.value || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { qty.value = Math.min(99, (+qty.value || 1) + 1); });
    var errEl = $('[data-form-error]', form);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return;
      var old = addBtn.textContent; addBtn.disabled = true;
      if (errEl) errEl.hidden = true;
      cartAdd(new FormData(form)).then(function () {
        addBtn.classList.add('done'); addBtn.textContent = MP.strings.added2;
        setTimeout(function () { addBtn.classList.remove('done'); addBtn.textContent = old; addBtn.disabled = false; }, 1800);
      }).catch(function (err) {
        addBtn.disabled = false; addBtn.textContent = old;
        if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
      });
    });
    if (sbAdd) sbAdd.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click(); });
    if (sbar && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var s = !e.isIntersecting && e.boundingClientRect.top < 0;
          sbar.classList.toggle('show', s); sbar.setAttribute('aria-hidden', !s);
          if (sbAdd) sbAdd.tabIndex = s ? 0 : -1;
        });
      }).observe(addBtn);
    }
  });

  /* ---------- Empfehlungen ---------- */
  $$('[data-recs]').forEach(function (box) {
    if (box.children.length) return;
    fetch(box.dataset.url).then(function (r) { return r.text(); }).then(function (t) {
      var doc = new DOMParser().parseFromString(t, 'text/html');
      var n = $('[data-recs]', doc);
      if (n && n.innerHTML.trim()) { box.innerHTML = n.innerHTML; initReveal(box); }
    }).catch(function () {});
  });

  /* ---------- Kollektion ---------- */
  var fdr = $('[data-filter-drawer]');
  if (fdr) {
    var fDlg = Dialog(fdr);
    $$('[data-filter-open]').forEach(function (b) { b.addEventListener('click', function () { fDlg.open('.x'); }); });
    fdr.addEventListener('click', function (e) { if (e.target.closest('[data-filter-close]')) fDlg.close(); });
  }
  $$('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); location.href = u.toString();
    });
  });
  $$('[data-more]').forEach(function (more) {
    var btn = $('[data-load-more]', more), grid = $('[data-grid]'), prog = $('[data-progress]', more), bar = $('[data-bar]', more), pag = $('[data-pagination]');
    if (!btn || !grid) return;
    btn.hidden = false; if (pag) pag.hidden = true;
    btn.addEventListener('click', function () {
      var url = btn.dataset.next; btn.disabled = true;
      fetch(url).then(function (r) { return r.text(); }).then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html');
        $$('[data-grid] > .pcard', doc).forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
        var nb = $('[data-load-more]', doc), np = $('[data-progress]', doc), nbar = $('[data-bar]', doc);
        if (np && prog) prog.textContent = np.textContent;
        if (nbar && bar) bar.style.setProperty('--w', nbar.style.getPropertyValue('--w'));
        if (nb) { btn.dataset.next = nb.dataset.next; btn.disabled = false; } else btn.hidden = true;
      }).catch(function () { btn.disabled = false; toast(MP.strings.error); });
    });
  });

  /* ---------- Formulare ---------- */
  function validate(form) {
    var ok = true;
    $$('.fld[data-f]', form).forEach(function (w) {
      var i = $('input,textarea', w), v = i.value.trim();
      var bad = !v || (i.type === 'email' && !/^\S+@\S+\.\S+$/.test(v));
      w.classList.toggle('bad', bad); if (bad && ok) { i.focus(); ok = false; }
    });
    var c = $('.fld[data-c]', form);
    if (c) { var cb = $('input[type=checkbox]', c); c.classList.toggle('bad', !cb.checked); if (!cb.checked && ok) { cb.focus(); ok = false; } }
    return ok;
  }
  $$('form[data-validate]').forEach(function (f) {
    f.addEventListener('submit', function (e) { if (!validate(f)) e.preventDefault(); });
  });

  /* ---------- Widerruf ---------- */
  $$('form[data-withdrawal]').forEach(function (form) {
    var steps = $$('[data-step]', form), tabs = $$('[data-step-tab]');
    function step(n) {
      steps.forEach(function (s) { s.hidden = +s.dataset.step !== n; });
      tabs.forEach(function (t) { t.classList.toggle('on', +t.dataset.stepTab <= n); });
      window.scrollTo({ top: 0, behavior: RM ? 'auto' : 'smooth' });
    }
    var scope = $$('input[name=scope]', form), arts = $('[data-articles]', form);
    scope.forEach(function (r) { r.addEventListener('change', function () { arts.hidden = $('input[name=scope]:checked', form).value !== 'Einzelne Artikel'; }); });
    var order = $('input[name="contact[Bestellnummer]"]', form), mail = $('input[name="contact[email]"]', form), nm = $('input[name="contact[name]"]', form);
    var esc = function (s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    // Shopifys Captcha haengt am submit-Event und an form.submit(); Enter in Schritt 1 fuehrt nur zur Pruefung
    form.addEventListener('submit', function (e) { e.preventDefault(); e.stopImmediatePropagation(); if (!steps[0].hidden) review(); }, true);
    $('[data-to-review]', form).addEventListener('click', function (e) { e.preventDefault(); review(); });
    function review() {
      if (!validate(form)) return;
      var sc = $('input[name=scope]:checked', form).value, art = $('[data-articles-input]', form).value.trim();
      var row = function (k, v) { return '<dt>' + k + '</dt><dd>' + esc(v) + '</dd>'; };
      $('[data-summary]', form).innerHTML = row('Bestellnummer', order.value) + row('E-Mail', mail.value) + row('Name', nm.value) + row('Widerruf', sc) + (sc === 'Einzelne Artikel' && art ? row('Artikel', art) : '');
      $('[data-body]', form).value = 'WIDERRUF\nBestellnummer: ' + order.value + '\nName: ' + nm.value + '\nE-Mail: ' + mail.value + '\nUmfang: ' + sc + (art ? '\nArtikel: ' + art : '') + '\nEingegangen: ' + new Date().toLocaleString('de-DE');
      step(2);
    }
    $('[data-back]', form).addEventListener('click', function () { step(1); });
    // Echtes Absenden statt fetch, sonst fehlt der Captcha-Token (400). Shopify leitet mit form.posted_successfully? zurueck.
    $('[data-confirm]', form).addEventListener('click', function () {
      var btn = this; btn.disabled = true; $('[data-error]', form).hidden = true;
      try { sessionStorage.setItem('mp-wdw', mail.value); } catch (e) {}
      form.submit();
      setTimeout(function () { btn.disabled = false; }, 5000);
    });
    if (!steps[2].hidden) {
      var m = '', d = new Date();
      try { m = sessionStorage.getItem('mp-wdw') || ''; sessionStorage.removeItem('mp-wdw'); } catch (e) {}
      $('[data-done-text]', form).textContent = 'Eingegangen am ' + d.toLocaleDateString('de-DE') + ' um ' + d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' }) + ' Uhr. Wir melden uns per E-Mail' + (m ? ' unter ' + m : '') + '.';
      tabs.forEach(function (t) { t.classList.add('on'); });
    }
  });

  /* ---------- Konto: Passwort vergessen ---------- */
  var lbox = $('#login-box'), rbox = $('#recover-box');
  if (lbox && rbox) {
    var toggle = function (rec) { lbox.hidden = rec; rbox.hidden = !rec; };
    $$('[data-recover-open]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); toggle(true); }); });
    $$('[data-recover-close]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); toggle(false); }); });
    if (location.hash === '#recover') toggle(true);
  }
  $$('select[data-default]').forEach(function (s) { if (s.dataset.default) s.value = s.dataset.default; });

  /* ---------- Cookie-Einstellungen (Banner kommt von Shopify) ---------- */
  var ckLinks = $$('[data-cookie-settings]');
  if (ckLinks.length && window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (err || !window.Shopify.customerPrivacy || !window.Shopify.customerPrivacy.showPreferences) return;
      ckLinks.forEach(function (a) {
        if (a.parentNode) a.parentNode.hidden = false;
        a.addEventListener('click', function (e) { e.preventDefault(); window.Shopify.customerPrivacy.showPreferences(); });
      });
    });
  }

  /* ---------- Akkordeon: sanftes Auf- und Zuklappen ---------- */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  $$('.acc details').forEach(function (d) {
    var sum = $('summary', d), body = $('.in', d);
    if (!sum || !body || !d.animate) return;
    var anim = null;
    sum.addEventListener('click', function (e) {
      if (reduceMotion) return;
      e.preventDefault();
      if (anim) anim.cancel();
      var ease = 'cubic-bezier(.22,.61,.36,1)';
      if (!d.open) {
        d.open = true;
        var h = body.offsetHeight, pb = getComputedStyle(body).paddingBottom;
        anim = body.animate([{ height: '0px', paddingBottom: '0px' }, { height: h + 'px', paddingBottom: pb }], { duration: 450, easing: ease });
        var fade = body.animate([{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'none' }], { duration: 400, delay: 180, easing: ease, fill: 'backwards' });
        anim.onfinish = anim.oncancel = function () { anim = null; };
      } else {
        var h0 = body.offsetHeight, pb0 = getComputedStyle(body).paddingBottom;
        anim = body.animate([{ height: h0 + 'px', paddingBottom: pb0, opacity: 1 }, { height: '0px', paddingBottom: '0px', opacity: 0 }], { duration: 350, easing: ease, fill: 'forwards' });
        var closing = anim;
        anim.onfinish = function () { d.open = false; closing.cancel(); anim = null; };
        anim.oncancel = function () { anim = null; };
      }
    });
  });
  /* Produktkarte: Farbpunkte tauschen Foto, Hover-Foto und Link */
  document.addEventListener('click', function (e) {
    var dot = e.target.closest ? e.target.closest('.pcard .dot') : null;
    if (!dot) return;
    var card = dot.closest('.pcard'); if (!card) return;
    $$('.dot', card).forEach(function (d) { var on = d === dot; d.classList.toggle('on', on); d.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    var main = $('.im img.main', card), alt = $('.im img.alt', card);
    if (main && dot.dataset.src) { main.src = dot.dataset.src; main.srcset = dot.dataset.srcset || ''; }
    if (alt) {
      if (dot.dataset.altSrc) { alt.src = dot.dataset.altSrc; alt.srcset = dot.dataset.altSrcset || ''; alt.hidden = false; }
      else alt.hidden = true;
    }
    if (dot.dataset.variant) {
      $$('a.im, a.tt', card).forEach(function (a) {
        var u = new URL(a.getAttribute('href'), location.origin); u.searchParams.set('variant', dot.dataset.variant); a.setAttribute('href', u.pathname + u.search);
      });
    }
  });
  /* Produktseite: Hinweis zum gewaehlten Optionswert (z. B. Laenge) */
  $$('fieldset[data-hints]').forEach(function (fs) {
    var out = $('p[data-hint]', fs); if (!out) return;
    function upd() { var c = $('input:checked', fs); var t = c ? c.getAttribute('data-hint') : ''; out.textContent = t || ''; out.hidden = !t; }
    fs.addEventListener('change', upd); upd();
  });
  /* ---------- Ankündigungsleiste: Texte wechseln ---------- */
  $$('[data-ab]').forEach(function (ab) {
    var items = $$('span', ab); if (items.length < 2 || RM) return;
    var i = 0, ms = Math.max(3, +ab.dataset.interval || 5) * 1000;
    setInterval(function () {
      items[i].classList.remove('on'); items[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % items.length;
      items[i].classList.add('on'); items[i].removeAttribute('aria-hidden');
    }, ms);
  });

  /* ---------- Ringgrößen: Link an der Option öffnet den Aufklappbereich und scrollt hin ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-rg-open]');
    if (!a) return;
    var d = document.getElementById('ringgroessen');
    if (!d) return;
    e.preventDefault();
    d.open = true;
    d.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------- Dialoge mit <dialog>: Größentabelle, Zoom ---------- */
  function dlgClose(d) { if (d && d.open) d.close(); }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-mdl-open]');
    if (o) { var d = document.getElementById(o.dataset.mdlOpen); if (d && d.showModal) { d.showModal(); } return; }
    var c = e.target.closest('[data-mdl-close]');
    if (c) { dlgClose(c.closest('dialog')); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('mdl')) dlgClose(e.target);
  });

  /* ---------- Produktseite: Lieferdatum, Restbestand, Geschenk, Zoom ---------- */
  function deliveryText(cfg) {
    var now = new Date(), day = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var dispatch = new Date(day), today = true;
    if (now.getHours() >= cfg.cutoff) { dispatch.setDate(dispatch.getDate() + 1); today = false; }
    while (dispatch.getDay() === 0 || dispatch.getDay() === 6) { dispatch.setDate(dispatch.getDate() + 1); today = false; }
    function addDays(start, n) {
      var x = new Date(start), c = 0;
      while (c < n) { x.setDate(x.getDate() + 1); var wd = x.getDay(); if (wd === 0 || (wd === 6 && !cfg.sat)) continue; c++; }
      return x;
    }
    var a = addDays(dispatch, cfg.min), b = addDays(dispatch, cfg.max);
    var f = function (d) { return d.toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' }); };
    var range = a.getTime() === b.getTime() ? 'am ' + f(a) : f(a) + ' bis ' + f(b);
    return (today ? 'Bestelle bis ' + cfg.cutoff + ' Uhr, ' : '') + 'Lieferung ' + range;
  }
  $$('[data-delivery]').forEach(function (el) {
    var t = $('[data-delivery-text]', el) || el;
    try {
      t.textContent = deliveryText({ cutoff: +el.dataset.cutoff || 14, min: +el.dataset.min || 2, max: +el.dataset.max || 4, sat: el.dataset.sat !== 'false' });
    } catch (e) {}
  });
  $$('[data-product-section]').forEach(function (sec) {
    var jsonEl = $('[data-product-json]', sec.parentElement) || $('[data-product-json]');
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var form = $('[data-product-form]', sec);
    var low = $('[data-low]', sec), dlv = $('[data-delivery]', sec), idInput = form ? $('[data-variant-id]', form) : null;
    function byId(id) { return product ? product.variants.filter(function (v) { return String(v.id) === String(id); })[0] : null; }
    function updateExtras() {
      var v = idInput ? byId(idInput.value) : null; if (!v) return;
      if (low) {
        var th = +low.dataset.threshold || 0, q = v.inventory_quantity;
        var managed = v.inventory_management === 'shopify' && v.inventory_policy !== 'continue';
        var show = th > 0 && managed && v.available && typeof q === 'number' && q > 0 && q <= th;
        low.hidden = !show; if (show) low.textContent = 'Nur noch ' + q + ' Stück verfügbar';
      }
      if (dlv) dlv.hidden = !v.available;
    }
    if (form && product) { form.addEventListener('change', function (e) { if (e.target.matches('[data-option-value]')) setTimeout(updateExtras, 0); }); updateExtras(); }
    var gift = $('[data-gift]', sec);
    if (gift) {
      var cb = $('[data-gift-toggle]', gift), msg = $('[data-gift-msg]', gift), ta = msg ? $('textarea', msg) : null;
      if (cb && msg) cb.addEventListener('change', function () { msg.hidden = !cb.checked; if (ta) { ta.disabled = !cb.checked; if (cb.checked) ta.focus(); else ta.value = ''; } });
    }
    var lb = $('[data-lightbox]', sec);
    if (lb && lb.showModal) {
      var zooms = $$('.gs[data-zoom]', sec), img = $('[data-lb-img]', lb), li = 0;
      function showZoom(i) { if (!zooms.length) return; li = (i + zooms.length) % zooms.length; img.src = zooms[li].dataset.zoom; var src = $('img', zooms[li]); img.alt = src ? (src.alt || '') : ''; }
      function openZoom(i) { showZoom(i); lb.showModal(); }
      zooms.forEach(function (gs, n) { gs.addEventListener('click', function (e) { if (e.target.closest('img')) openZoom(n); }); });
      var zb = $('[data-zoom-open]', sec);
      if (zb) zb.addEventListener('click', function () { var cur = $('[data-gcount]', sec); var n = cur ? (parseInt(cur.textContent, 10) || 1) - 1 : 0; openZoom(n); });
      var lp = $('[data-lb-prev]', lb), ln = $('[data-lb-next]', lb);
      if (lp) lp.addEventListener('click', function () { showZoom(li - 1); });
      if (ln) ln.addEventListener('click', function () { showZoom(li + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target === img) lb.close(); });
      lb.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') showZoom(li + 1); if (e.key === 'ArrowLeft') showZoom(li - 1); });
    }
  });
  /* ---------- Popup (Newsletter / Aktion) ---------- */
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  /* Newsletter bestätigt (/account/subscribe): Rabatt-Popup in diesem Browser nicht mehr zeigen */
  if ($('[data-nl-confirmed]')) store.set('mp_nl_done', '1');
  $$('[data-popup]').forEach(function (pp) {
    if (!pp.showModal) return;
    var key = 'mp_pp_' + (pp.dataset.key || 'popup'), days = +pp.dataset.days || 14, now = Date.now();
    var success = $('[data-popup-success]', pp), form = $('form', pp), timer = null, opened = false;
    function open() {
      if (opened || pp.open || openStack.length || document.hidden) return;
      opened = true; pp.showModal(); document.body.style.overflow = 'hidden';
      store.set(key, String(Date.now()));
    }
    pp.addEventListener('close', function () {
      clearTimeout(timer); store.set(key, String(Date.now()));
      if (!openStack.length) document.body.style.overflow = '';
    });
    pp.addEventListener('click', function (e) { if (e.target === pp) pp.close(); });
    var sent = null, failed = $('.errors', pp);
    if (success || failed) try { sent = sessionStorage.getItem('mp_pp_sent'); sessionStorage.removeItem('mp_pp_sent'); } catch (e) {}
    if (success) {
      store.set(key + '_done', '1');
      if (sent) { opened = true; pp.showModal(); document.body.style.overflow = 'hidden'; }
      return;
    }
    /* Fehler nach dem Absenden (z. B. ungültige Adresse): Popup gleich wieder zeigen */
    if (sent && failed) { opened = true; pp.showModal(); document.body.style.overflow = 'hidden'; }
    if (form) form.addEventListener('submit', function () { try { sessionStorage.setItem('mp_pp_sent', '1'); } catch (e) {} });
    var cta = $('[data-popup-cta]', pp);
    if (cta) cta.addEventListener('click', function () { store.set(key + '_done', '1'); });
    if (window.Shopify && window.Shopify.designMode) return;
    if (store.get(key + '_done') || (pp.dataset.key || '').indexOf('newsletter') === 0 && store.get('mp_nl_done')) return;
    var last = +store.get(key) || 0;
    if (last && now - last < days * 864e5) return;
    if (pp.dataset.mobile === 'false' && window.matchMedia('(max-width:800px)').matches) return;
    var delay = Math.max(3, +pp.dataset.delay || 10), scroll = +pp.dataset.scroll || 0, exit = pp.dataset.exit === 'true';
    timer = setTimeout(open, delay * 1000);
    if (scroll > 0) {
      var onScroll = function () {
        var h = document.documentElement.scrollHeight - innerHeight; if (h <= 0) return;
        if (window.scrollY / h * 100 >= scroll) { window.removeEventListener('scroll', onScroll); open(); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    if (exit && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) open(); });
    }
  });
  /* Newsletter: eingetragene Adresse merken und nach der Anmeldung anzeigen */
  $$('form[action*="/contact"]').forEach(function (f) {
    var tags = f.querySelector('[name="contact[tags]"]');
    if (!tags || tags.value.indexOf('newsletter') < 0) return;
    f.addEventListener('submit', function () {
      var em = f.querySelector('[name="contact[email]"]');
      try { if (em && em.value) sessionStorage.setItem('mp_nl_mail', em.value.trim()); } catch (e) {}
    });
  });
  $$('[data-pp-mail]').forEach(function (el) {
    var mail = null; try { mail = sessionStorage.getItem('mp_nl_mail'); } catch (e) {}
    if (!mail) return;
    $('span', el).textContent = mail; el.hidden = false;
  });
  /* Theme-Editor: Popup zeigen, wenn der Bereich angeklickt wird */
  document.addEventListener('shopify:section:select', function (e) {
    var pp = $('[data-popup]', e.target); if (pp && pp.showModal && !pp.open) pp.showModal();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var pp = $('[data-popup]', e.target); if (pp && pp.open) pp.close();
  });

  /* ---------- Karussell-Pfeile (auch für nachgeladene Bereiche) ---------- */
  var railStep = function (rail) {
    var item = rail.firstElementChild; if (!item) return rail.clientWidth * 0.8;
    var cs = getComputedStyle(rail); var gap = parseFloat(cs.columnGap || cs.gap) || 0;
    return item.getBoundingClientRect().width + gap;
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rail-prev],[data-rail-next]'); if (!b) return;
    var wrap = b.closest('[data-rail-wrap]'); var rail = wrap && $('[data-rail]', wrap); if (!rail) return;
    var dir = b.hasAttribute('data-rail-prev') ? -1 : 1;
    rail.scrollBy({ left: dir * railStep(rail), behavior: RM ? 'auto' : 'smooth' });
  });
  document.addEventListener('keydown', function (e) {
    var rail = e.target.closest && e.target.closest('[data-rail]'); if (!rail || rail.hasAttribute('data-rail-keys')) return;
    if (e.key === 'ArrowRight') { e.preventDefault(); rail.scrollBy({ left: railStep(rail), behavior: RM ? 'auto' : 'smooth' }); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); rail.scrollBy({ left: -railStep(rail), behavior: RM ? 'auto' : 'smooth' }); }
  });
})();
